var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserswhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6147 6.92704V13.072C18.6147 14.0782 18.0757 15.0125 17.2042 15.5246L11.8678 18.6061C10.9964 19.1092 9.91832 19.1092 9.0379 18.6061L3.70148 15.5246C2.83005 15.0215 2.29102 14.0871 2.29102 13.072V6.92704C2.29102 5.92085 2.83005 4.98649 3.70148 4.47441L9.0379 1.39295C9.90933 0.889851 10.9874 0.889851 11.8678 1.39295L17.2042 4.47441C18.0757 4.98649 18.6147 5.91186 18.6147 6.92704Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4575 9.10052C11.6136 9.10052 12.5507 8.16333 12.5507 7.00726C12.5507 5.8512 11.6136 4.91406 10.4575 4.91406C9.30143 4.91406 8.36426 5.8512 8.36426 7.00726C8.36426 8.16333 9.30143 9.10052 10.4575 9.10052Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0509 14.1855C14.0509 12.5684 12.4427 11.2568 10.4573 11.2568C8.47188 11.2568 6.86377 12.5684 6.86377 14.1855",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserswhite);
export default __webpack_public_path__ + "static/media/userswhite.d87f1d0b13b094346e12349385876f11.svg";
export { ForwardRef as ReactComponent };